import { render } from "./WCModal.vue?vue&type=template&id=55cac662&scoped=true"
import script from "./WCModal.vue?vue&type=script&lang=js"
export * from "./WCModal.vue?vue&type=script&lang=js"

import "./WCModal.vue?vue&type=style&index=0&id=55cac662&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cac662"]])

export default __exports__